export type InviteSource = 'web' | 'bot' | 'code'
export interface PendingInvitation {
  code: string
  via: InviteSource
}
const KEY = 'snitch-invitation-v1'
const MAX_AGE = 24 * 60 * 60 * 1000

export function normalizeInviteCode(value: string): string | null {
  const code = value.trim().toUpperCase()
  return /^[A-Z0-9][A-Z0-9-]{2,31}$/.test(code) ? code : null
}
export function inviteSource(value: unknown): InviteSource {
  return value === 'bot' || value === 'code' ? value : 'web'
}
export function invitationTarget(code: string, via: InviteSource = 'web') {
  return `/i/${encodeURIComponent(code)}${via === 'web' ? '' : `?via=${via}`}`
}
export function invitationFromTarget(value: unknown): PendingInvitation | null {
  if (typeof value !== 'string' || !value.startsWith('/i/')) return null
  try {
    const url = new URL(value, 'https://snitch.invalid')
    if (url.origin !== 'https://snitch.invalid') return null
    const raw = /^\/i\/([^/]+)$/.exec(url.pathname)?.[1]
    const code = raw ? normalizeInviteCode(decodeURIComponent(raw)) : null
    return code ? { code, via: inviteSource(url.searchParams.get('via')) } : null
  } catch {
    return null
  }
}
export function rememberInvitation(value: PendingInvitation) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ ...value, savedAt: Date.now() }))
  } catch {
    /* The signed return path still carries it. */
  }
}
export function forgetInvitation() {
  try {
    sessionStorage.removeItem(KEY)
  } catch {
    /* Storage may be disabled. */
  }
}
export function pendingInvitation(): PendingInvitation | null {
  try {
    const p = JSON.parse(sessionStorage.getItem(KEY) ?? 'null')
    if (
      !p ||
      typeof p.code !== 'string' ||
      typeof p.savedAt !== 'number' ||
      Date.now() - p.savedAt > MAX_AGE ||
      p.savedAt > Date.now()
    )
      return null
    const code = normalizeInviteCode(p.code)
    return code ? { code, via: inviteSource(p.via) } : null
  } catch {
    return null
  }
}
